import React from 'react';
import ReactDOM from 'react-dom';
import { Router } from 'react-router-dom';
import { history } from './history';
import App from './components/App';
import Config from './config/Config';
import ReactPixel from 'react-facebook-pixel';
import TagManager from 'react-gtm-module';
import { PersistGate } from 'redux-persist/integration/react';
import { Provider } from 'react-redux';
import { store, persistor } from './getStore.js';
import * as serviceWorker from './serviceWorker.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.min.js';
import AudioRecorder from 'audio-recorder-polyfill';
import { isIos } from './utils/commonFunctions';

if (isIos()) {
	window.MediaRecorder = AudioRecorder;
}

ReactPixel.init('942234445902858');
ReactPixel.pageView(); // For tracking page view
ReactPixel.track('ViewContent'); // For tracking default events, more info about events and data https://developers.facebook.com/docs/ads-for-websites/pixel-events/v2.9

const tagManagerArgs = {
	gtmId: Config.GTM_TAG,
};

TagManager.initialize(tagManagerArgs);

ReactDOM.render(
	<Provider store={store}>
		<Router history={history}>
			<PersistGate persistor={persistor}>
				<App />
			</PersistGate>
		</Router>
	</Provider>,
	document.getElementById('myDiv'),
);

serviceWorker.unregister();
